import { jsx as x } from "react/jsx-runtime";
import { c as n } from "react/compiler-runtime";
import { Checkbox as y } from "@mui/material";
import "../../../chunks/Map.js";
import "../../../styles/theme.js";
import "react";
import "@mui/icons-material";
import "../FormControl/FormControl.js";
import { FormControlLabel as h } from "../FormControlLabel/FormControlLabel.js";
import "@react-google-maps/api";
import "../../../chunks/index.esm.js";
import "react-dom/server";
import '../../../assets/FilterWrapper.css';import '../../../assets/map.css';/* empty css                   */
import "../Grid/Grid.js";
import "../Paper/Paper.js";
import "../Box/Box.js";
import "../Radio/Radio.js";
import "../RadioGroup/RadioGroup.js";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "../Menu/Menu.js";
import "../MenuItem/MenuItem.js";
import "../Typography/Typography.js";
import "@mui/icons-material/KeyboardArrowDown";
import "@mui/icons-material/Warning";
import "@mui/material/styles";
import "../Table/Table.js";
import "../TableBody/TableBody.js";
import "../TableHead/TableHead.js";
import "../TableRow/TableRow.js";
import "../TableCell/TableCell.js";
import "../ToggleButton/ToggleButton.js";
import "../ToggleButtonGroup/ToggleButtonGroup.js";
import "@mui/icons-material/ExpandMore";
import "../Stepper/Stepper.js";
import "../Step/Step.js";
import "../StepLabel/StepLabel.js";
import "../Link/Link.js";
import "../LoadingButton/LoadingButton.js";
import "../LinearProgress/LinearProgress.js";
import "../Stack/Stack.js";
import "../Card/Card.js";
import "../CardActions/CardActions.js";
import "../FormHelperText/FormHelperText.js";
import "../AccordionDetails/AccordionDetails.js";
import "../TableContainer/TableContainer.js";
import "@mui/material/DialogTitle";
import "@mui/material/DialogContent";
import "@mui/material/DialogActions";
import "@mui/material/IconButton";
import "@mui/icons-material/Close";
import "@mui/material/Typography";
import "@mui/material/Dialog";
import "@mui/icons-material/InfoOutlined";
import "@mui/icons-material/ArrowDropDown";
import "@mui/icons-material/ArrowDropUp";
import "@mui/icons-material/ArrowLeft";
import "@mui/icons-material/ArrowRight";
import "highcharts-react-official";
import "highcharts";
import "moment-timezone";
import "highcharts/highcharts";
import "../../molecules/Widgets/WidgetTimelineGraph/WidgetTimelineGraph.styles.js";
import "react-dom/client";
import "reactflow";
import "reactflow/dist/style.css";
import "dagre";
import "../../molecules/NetworkMap/NetworkMapUtils.js";
import "@mui/icons-material/FilterAlt";
/* empty css                            */
import "@mui/material/Menu";
import "@mui/material/FormControl";
import "@mui/material/ListSubheader";
import "lodash";
import "@mui/icons-material/Search";
import "@mui/material/TextField";
import "@mui/material/Fab";
import "@mui/material/TextareaAutosize";
import "@mui/material/InputLabel";
import "@mui/material/CardContent";
import "@mui/material/CardHeader";
import "@mui/material/Collapse";
import "@mui/material/ClickAwayListener";
import "@mui/material/Grow";
import "@mui/material/Fade";
import "@mui/material/Popper";
import "@mui/material/MenuList";
import "@mui/material/Breadcrumbs";
import "@mui/material/Modal";
import "@mui/material/FormGroup";
import "@mui/material/Accordion";
import "@mui/material/AccordionSummary";
import "@mui/material/AccordionDetails";
import "@mui/material/Select";
import "@mui/material/Autocomplete";
import "@mui/material/InputAdornment";
import "@mui/material/AlertTitle";
import "@mui/material/ListItemText";
import "@mui/material/List";
import "@mui/material/ListItem";
import "@mui/material/ListItemButton";
import "@mui/material/ListItemAvatar";
import "@mui/material/Backdrop";
import "@mui/material/ListItemIcon";
import "@mui/material/Popover";
import "@mui/material/Drawer";
import "@mui/material/CardMedia";
import "@mui/material/Snackbar";
import "@mui/material/TablePagination";
import "@mui/material/colors";
import "@mui/material/useMediaQuery";
import "@mui/material/OutlinedInput";
import "@mui/icons-material/CheckCircle";
import "@mui/icons-material/RestartAlt";
import "@mui/icons-material/Info";
import "@mui/icons-material/Add";
import "@mui/icons-material/Build";
import "@mui/icons-material/Menu";
import "../../organisms/SunburstGraph/SunburstGraph.js";
import "../../organisms/RadarGraph/RadarGraph.js";
import "../../organisms/ScoreGauge/ScoreGauge.js";
import "@mui/icons-material/EventOutlined";
import "@mui/icons-material/KeyboardArrowDownOutlined";
import "@mui/icons-material/CloseRounded";
import "../../organisms/DateTimeSelector/DateTimeSelectorMenu.js";
import "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import "../../../chunks/TableContext.js";
import "@tanstack/react-table";
import "@tanstack/react-virtual";
import "@mui/icons-material/FilterAltOff";
import "react-window";
import "../../organisms/Table/TimeRangeFilter.js";
import "@mui/icons-material/KeyboardDoubleArrowLeft";
import "@mui/icons-material/KeyboardDoubleArrowRight";
import "@mui/icons-material/KeyboardArrowLeft";
import "@mui/icons-material/KeyboardArrowRight";
import "@mui/icons-material/ViewWeek";
import "@mui/icons-material/DragIndicator";
import "@mui/icons-material/ArrowForward";
import "../../../chunks/ChatbotContext.js";
import "react-markdown";
import "remark-gfm";
import "rehype-raw";
import "rehype-sanitize";
import "../../organisms/ReactMap/index.js";
import "@mui/material/Button";
import "../../organisms/ReactMap/GMapStatic.js";
import "@mui/icons-material/Clear";
function pr(a) {
  const t = n(20);
  let i, o, m, r;
  t[0] !== a ? ({
    label: i,
    sx: r,
    labelStyles: o,
    ...m
  } = a, t[0] = a, t[1] = i, t[2] = o, t[3] = m, t[4] = r) : (i = t[1], o = t[2], m = t[3], r = t[4]);
  let p;
  t[5] !== r ? (p = Array.isArray(r) ? r : [r], t[5] = r, t[6] = p) : p = t[6];
  let e;
  t[7] !== p ? (e = [...p, b.checkboxStyles], t[7] = p, t[8] = e) : e = t[8];
  let l;
  t[9] !== m || t[10] !== e ? (l = /* @__PURE__ */ x(y, { sx: e, ...m }), t[9] = m, t[10] = e, t[11] = l) : l = t[11];
  let s;
  t[12] !== o ? (s = Array.isArray(o) ? o : [o], t[12] = o, t[13] = s) : s = t[13];
  let c;
  t[14] !== s ? (c = [...s, b.labelStyles], t[14] = s, t[15] = c) : c = t[15];
  let f;
  return t[16] !== i || t[17] !== l || t[18] !== c ? (f = /* @__PURE__ */ x(h, { control: l, label: i, sx: c }), t[16] = i, t[17] = l, t[18] = c, t[19] = f) : f = t[19], f;
}
const b = {
  checkboxStyles: {
    p: 0
  },
  labelStyles: {
    gap: "6px",
    marginRight: "0px",
    width: "fit-content"
  }
};
export {
  pr as Checkbox
};
